export const VegIcon = () => (
  <span
    className="inline-flex h-4 w-4 items-center justify-center rounded-[3px] border-[1.5px] border-green-700 shrink-0"
    title="Vegetarian"
    aria-label="Vegetarian"
    data-testid="veg-icon"
  >
    <span className="h-1.5 w-1.5 rounded-full bg-green-700" />
  </span>
);

export const DishCard = ({ dish, compact = false }) => (
  <article
    data-testid={`dish-card-${dish.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className="group flex flex-col overflow-hidden rounded-2xl bg-white border border-line transition-[box-shadow,transform] duration-500 hover:shadow-[0_16px_40px_rgba(26,54,38,0.08)] hover:-translate-y-1"
  >
    {dish.image ? (
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={dish.image}
          alt={dish.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {dish.popular && (
          <span
            data-testid="dish-popular-tag"
            className="absolute top-4 left-4 rounded-full bg-gold px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-forest"
          >
            Popular
          </span>
        )}
      </div>
    ) : (
      <div className="relative flex aspect-[4/3] items-center justify-center bg-sand overflow-hidden">
        <span className="font-display italic text-6xl text-forest/15 select-none">
          {dish.name.charAt(0)}
        </span>
        {dish.popular && (
          <span
            data-testid="dish-popular-tag"
            className="absolute top-4 left-4 rounded-full bg-gold px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-forest"
          >
            Popular
          </span>
        )}
      </div>
    )}
    <div className="flex flex-1 flex-col p-5 md:p-6">
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-display text-lg md:text-xl leading-snug text-charcoal">{dish.name}</h3>
        <VegIcon />
      </div>
      <p className="mt-2 text-sm leading-relaxed text-charcoal/60 flex-1">{dish.description}</p>
      {!compact && (
        <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-forest/60">
          {dish.category}
        </p>
      )}
    </div>
  </article>
);
